export const supported_companies = [{
  id: 0,
  name: "apple",
  email_domains: ["@apple.com"]
}];